<template><div><h1 id="brief-schreiben" tabindex="-1"><a class="header-anchor" href="#brief-schreiben"><span>Brief schreiben</span></a></h1>
<p>Brief schreiben — Brief direkt aus der Personenansicht erstellen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit dieser Funktion lässt sich ein MS-Word-Dokument direkt aus der Personenansicht erstellen. funtrade erstellt ein Dokument aus einer frei wählbaren Vorlage (.docx oder .dotx). Der Brief wird als Anhang zu einer <RouteLink to="/referenz/refs/ft.refdata.aktionen.html" title="Aktionen">Aktion</RouteLink> verknüpft.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Personen → Personen → Brief schreiben... (Kontextmenü)</p>
<h3 id="verwendung" tabindex="-1"><a class="header-anchor" href="#verwendung"><span>Verwendung</span></a></h3>
<ol>
<li>
<p>Bei einer Person &quot;Brief schreiben ...&quot; wählen.</p>
</li>
<li>
<p>Eine Vorlage wählen (siehe &quot;Einrichten&quot;, falls keine Vorlagen angezeigt werden).</p>
</li>
<li>
<p>Eine bestehende Aktion wählen oder eine neue erfassen.</p>
</li>
<li>
<p>In MS-Word den Brief bearbeiten, drucken und speichern. Man muss nicht Speichern unter... wählen, kann das aber machen, wenn man eine Kopie des Briefes ausserhalb von funtrade wünscht.</p>
</li>
<li>
<p>Das MS-Word-Dokument muss nun geschlossen werden damit der Prozess weiter läuft.</p>
</li>
</ol>
<p>Pfad: <code v-pre>Personen → Tabellen → Briefvorlagen</code></p>
</div></template>


